import React from 'react'
import ResellerLoginComponent from 'components/Panel/Reseller/Login'
const ResellerLoginContainer = () => {
  return (
    <ResellerLoginComponent/>
  )
}

export default ResellerLoginContainer